/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./shareScreenSetting.vue?vue&type=template&id=a78bc0f2&scoped=true&"
import script from "./shareScreenSetting.vue?vue&type=script&lang=js&"
export * from "./shareScreenSetting.vue?vue&type=script&lang=js&"
import style0 from "./shareScreenSetting.vue?vue&type=style&index=0&id=a78bc0f2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a78bc0f2",
  null
  
)

export default component.exports